<!--
 * @Author: your name
 * @Date: 2021-09-09 13:50:41
 * @LastEditTime: 2021-09-10 15:00:12
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \taotan_admin\src\views\marriageGetName\babyName\babyMameStyleSet.vue
-->
<template>
  <div>
    <div
      class="style-outer"
      v-for="(item, index) in tableDataStyle"
      :key="item.intitleStyleId"
      @click="babyNameConnet(item)"
    >
      <div class="isCheck">
        <i
          :class="[
            'el-icon-success',
            { active_class: activeIndex == item.intitleStyleId },
          ]"
        ></i>
      </div>
      <el-image
        style="width: 100%; height: 152px"
        :src="item.icon"
        fit="cover"
      ></el-image>
      <div class="style__font">{{ item.name }}</div>
    </div>
  </div>
</template>

<script>
import { isEmpty } from "@utils/tools/index";
export default {
  data() {
    return {
      activeIndex: 0,
      tableDataStyle: [],
      intitleId: this.$route.query.uid,
      pageLoading: false, // 页面loading
      listParams: {
        styleType: "gxjg",
      },
    };
  },
  created() {
    this.queryStyleData();
  },
  methods: {
    /*
     *@method: queryStyleData
     *@param:
     *@desc:  获取样式列表
     *@Date: 2021-09-10 14:32:04
     */
    async queryStyleData() {
      this.pageLoading = true;
      const { data: resData } = await this.$get("intitle/style/list", {
        params: {
          ...this.listParams,
        },
      });
      this.pageLoading = false;
      if (!isEmpty(resData.data)) {
        this.tableDataStyle = resData.data.sort(function(a, b) {
          return b.seq - a.seq;
        });
        this.tableDataStyle.map((item) => {});
        this.$get(`/intitle/info/style/${this.intitleId}/gxjg`, {}).then(
          (res) => {
            if(res.data.data){
              this.activeIndex=res.data.data.intitleStyleId;
            }
            console.log(222, res.data);
          }
        );
      } else {
        this.tableDataStyle = [];
      }
    },
    /*
     *@method: babyNameConnet
     *@param: {Object} 当前行对象
     *@desc:  关联宝宝取名样式
     *@Date: 2021-09-10 13:56:41
     */
    async babyNameConnet(obj) {
      const { data: resData } = await this.$post(`/intitle/info/style`, {
        intitleId: this.intitleId, // 宝宝取名UID
        intitleStyleId: obj.intitleStyleId, //样式ID
        styleType: obj.styleType, //
      });

      if (resData.result != 200) return;
      this.activeIndex = obj.id;
      this.$message.success("修改成功!");
      this.queryStyleData();
    },
    /*
     *@method: getBabyMameDes
     *@param:
     *@desc:  宝宝取名样式ID
     *@Date: 2021-09-10 10:57:49
     */
    getBabyMameStyle() {
      this.$get(`/intitle/info/style/${this.intitleId}/cpjg`, {}).then();
      this.pageLoading = false;
      if (resData.result != 200) return;
      this.explainParams = resData.data;
    },
  },
};
</script>
<style lang="scss" scoped>
.style-outer {
  background: #fff;
  float: left;
  margin: 0 20px 20px 0;
  width: 200px;
  height: 200px;
  border: 1px solid #ddd;
  cursor: pointer;
  position: relative;
  .style__font {
    line-height: 45px;
    margin: 0 0 0 10px;
  }
  .isCheck {
    position: absolute;
    top: 0;
    right: 5px;
    z-index: 2;
    .el-icon-success {
      font-size: 20px;
      color: #ddd;
    }
  }
}

.active_class {
  // border: 1px solid #000 !important;
  color: #67c23a !important ;
}
</style>
